// extracted by mini-css-extract-plugin
export default {"zhiboshi":"index_zhiboshi_zajgw","link":"index_link_Ln3Xb"};